import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../config";

export const accountingYearsConstants = {
  GET_RISCONTI_LIST_START: "GET_RISCONTI_LIST_START",
  GET_RISCONTI_LIST_SUCCESS: "GET_RISCONTI_LIST_SUCCESS",
  GET_RISCONTI_LIST_ERROR:  "GET_RISCONTI_LIST_ERROR",
  GET_DEPRECIATION_LIST_START: "GET_DEPRECIATION_LIST_START",
  GET_DEPRECIATION_LIST_SUCCESS: "GET_DEPRECIATION_LIST_SUCCESS",
  GET_DEPRECIATION_LIST_ERROR:  "GET_DEPRECIATION_LIST_ERROR"
};

export function getAccountingYearsList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = getState().main?.companyUuidSelected;
    const managerId = getState().main?.accountantUuidSelected;        
    const url = `${API_PRECOG_URL_V1}/ledger/accountingPeriods?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      const request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            resolve(result);
          } else {
            reject(JSON.parse(JSON.stringify(result)));
          }
        })
        .catch((response) => {
          reject(JSON.parse(JSON.stringify(response)));
        });
    });
  };
}

export function getAccountingYearsTasks(accountingPeriodId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = getState().main?.companyUuidSelected;
    const managerId = getState().main?.accountantUuidSelected;    
    
    const url = `${API_PRECOG_URL_V1}/ledger/accountingPeriods/${accountingPeriodId}/tasks?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      const request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            resolve(result);
          } else {
            reject(JSON.parse(JSON.stringify(result)));
          }
        })
        .catch((response) => {
          reject(JSON.parse(JSON.stringify(response)));
        });
    });
  };
}

export function getRiscontiList(accountingPeriodId) {
  return (dispatch, getState) => {
    const auth = getState().auth;  
    const itemId = getState().main?.companyUuidSelected;
    const managerId = getState().main?.accountantUuidSelected; 
    const url = `${API_PRECOG_URL_V1}/ledger/accountingPeriods/${accountingPeriodId}/deferrals?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      const request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
        }
      };

      dispatch({
        type: accountingYearsConstants.GET_RISCONTI_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: accountingYearsConstants.GET_RISCONTI_LIST_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: accountingYearsConstants.GET_RISCONTI_LIST_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: accountingYearsConstants.GET_RISCONTI_LIST_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function createAccountingYearsList(startPerion, endPeriod) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = getState().main?.companyUuidSelected;
    const managerId = getState().main?.accountantUuidSelected;    
  
    const url = `${API_PRECOG_URL_V1}/ledger/accountingPeriods?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      const request = {
        method: "POST",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
        },
        data: {          
          startDate: startPerion,
          endDate: endPeriod          
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            resolve(result);
          } else {
            reject();
          }
        })
        .catch((response) => {
          reject(JSON.parse(JSON.stringify(response)));
        });
    });
  };
}

export function saveDestinationAmount(data) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = getState().main?.companyUuidSelected;
    const managerId = getState().main?.accountantUuidSelected;    
  
    const url = `${API_PRECOG_URL_V1}/ledger/allocateNetIncome?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      const request = {
        method: "POST",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
        },
        data: data
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            resolve(result);
          } else {
            reject();
          }
        })
        .catch((response) => {
          reject(JSON.parse(JSON.stringify(response)));
        });
    });
  };
}

export function getDepreciationList(data) {
  return (dispatch, getState) => {
    const auth = getState().auth;  
    const itemId = getState().main?.companyUuidSelected;
    const managerId = getState().main?.accountantUuidSelected; 
    const url = `${API_PRECOG_URL_V1}/asset/simulation/depreciation/?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      const request = {
        method: "POST",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
        },
        data: data
      };

      dispatch({
        type: accountingYearsConstants.GET_DEPRECIATION_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: accountingYearsConstants.GET_DEPRECIATION_LIST_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: accountingYearsConstants.GET_DEPRECIATION_LIST_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: accountingYearsConstants.GET_DEPRECIATION_LIST_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}
